@if (!!content) {
  <div class="kyd-smartphone-terms main" [innerHtml]="content"></div>
}
